exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".online-area[data-v-0a311cc8]{margin:30px}.online-item[data-v-0a311cc8]{display:inline;font-weight:700;font-size:24px}.online-id[data-v-0a311cc8]{display:inline;font-size:13px}", ""]);

// exports
